import { ACTIVITY_DETAILS_COLORS, ACTIVITY_DETAILS_TYPOGRAPHY } from './constants';

interface ActivityDescriptionProps {
  description: string;
}

/**
 * ActivityDescription Component
 * 
 * Activity description text.
 * Responsive: Text scales 16px → 18px → 20px.
 */
export default function ActivityDescription({ description }: ActivityDescriptionProps) {
  return (
    <p
      className={`${ACTIVITY_DETAILS_TYPOGRAPHY.body.weight} ${ACTIVITY_DETAILS_TYPOGRAPHY.body.sizeClasses} ${ACTIVITY_DETAILS_TYPOGRAPHY.body.leading} mt-4 px-6 sm:px-8 md:px-10 lg:px-12`}
      style={{
        fontFamily: 'DM Sans, sans-serif',
        color: ACTIVITY_DETAILS_COLORS.textBody,
        margin: 0,
        marginTop: '16px',
      }}
    >
      {description}
    </p>
  );
}
